import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * Productivity Module — Employee Productivity Tracking
 *
 * Provides managers visibility into employee productivity patterns,
 * time allocation across apps/domains, and classification management.
 */
const productivityModule: AppModule = {
    id: 'productivity',
    navigation: {
        label: 'Productivity',
        icon: 'bar-chart-3',
        path: '/productivity',
        order: 77,
        moduleKey: 'productivity',
        pages: [
            {
                label: 'Dashboard',
                path: '/productivity',
                icon: 'layout-dashboard',
            },
            {
                label: 'Employees',
                path: '/productivity/employees',
                icon: 'users',
            },
            {
                label: 'Classifications',
                path: '/productivity/classifications',
                icon: 'tags',
            },
        ],
    },
    routes,
}

export default productivityModule
